export enum ChargeStatus {
    Pending = 'pending',
    Initiated = 'initiated',
    InTransit = 'in-transit',
    Done = 'done',
    Failed = 'failed',
    Canceled = 'canceled',
    Scheduled = 'scheduled',
    PartiallyRefunded = 'partially-refunded',
    Refunded = 'refunded',
    RefundFailed = 'refund-failed',
    RefundInitiated = 'refund-initiated',
    Disputed = 'disputed',
    MarkedAsPaid = 'marked-as-paid',
    Submitted = 'submitted',
}
